import languageCountryMap from './language-country';

export function languageDisplayName(
  localeCode: string,
  displayLanguage?: string,
): string {
  if (!localeCode) {
    return localeCode;
  }
  const code = localeCode?.replace('_', '-');
  const displayName = new Intl.DisplayNames(code, {
    type: 'language',
  }).of(displayLanguage || code);
  return (
    `${displayName?.[0].toUpperCase()}${displayName?.slice(1)}` || localeCode
  );
}

export function countryByLanguage(localeCode: string): string {
  if (!localeCode) {
    return localeCode;
  }
  const languageAndCountry = localeCode.toUpperCase().split(/-|_/);
  const language = languageAndCountry.shift();
  const country = languageAndCountry.pop();
  return country || languageCountryMap[language.toLowerCase()] || language;
}
